<script>
import BOGen from '@helper/BOGen';
export default {
  name: "FileManager",
  props:{
    inline: Boolean,
  },
  data(){
    return {
      // Configuration
      params: {},
      // Var
      show: false,
      selectedFolder: {},
      paths: [],
      filter: {search:""},
      callback: null,
    }
  },
  computed:{
    // Configuration
    explore(){ return this.params.explore || false },
    allowedFileTypes(){ return this.params.allowedFileTypes || "jpg,jpeg,png,gif,docs,pdf,doc,xls,xlsx,txt" },
    multiple(){ return this.params.multiple || false },
    // Variable
    setPath(){
      var v = this.selectedFolder
      if(!v.dirname) return ""
      return v.dirname == "." ? v.filename.replaceAll(/\./,"") : v.filename.replaceAll(/()./,"")+"/"+v.filename.replaceAll(/\./,"");
    },
    dataPaths(){
      if(!this.filter.search) return this.paths;
      return this.paths.filter((x)=>{ return x.basename.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1 })
    },
    selectedFiles(){
      return this.paths.filter((x)=>{ return x.selected === true })
    }
  },
  mounted(){
    global.FileManager = this
    if(this.inline){
      this.refreshPath()
    }
  },
  methods:{
    open(cb, params = {}){
      this.params = params
      if(params.type){
        this.selectedFolder = {dirname:".",filename:params.type}
      }
      this.show = true
      this.refreshPath()
      this.callback = cb
    },
    close(){
      if(this.inline){
        return window.close()
      }
      this.paths = []
      this.selectedFolder = {}
      this.show = false
    },
    refreshPath(){
      BOGen.apirest("/uploader-manager", {path:this.setPath}, (err, resp)=>{
        if(err) return
        this.paths = resp.filter((x)=>{ 
          return (x.extension ? this.allowedFileTypes.indexOf(x.extension) > -1 : true) && (this.explore ? true : x.basename != "Up")
        })
        this.filter.search = ""
        if(this.inline){
          this.show = true
          this.params = {explore:true}
        }
      })
    },
    fileAction(k,v){
      if(!v.extension){
        this.selectedFolder = v
        this.refreshPath()
      }else{
        if(!this.multiple){
          this.paths.forEach((v)=>{ this.$set(v,'selected', false) })
        }
        this.$set(v, 'selected', !v.selected);
      }
    },
    choose(){
      if(!this.selectedFiles.length) return
      var files = this.multiple ? this.selectedFiles : this.selectedFiles[0]
      if(this.callback) this.callback(files)
      if(this.inline){
        window.opener.CKEDITOR.tools.callFunction(this.$route.query.CKEditorFuncNum, files.targetfile);
      }
      this.close()
    }
  }
}
</script>

<template>
  <div id="FileManager" :class="{inline:inline}" v-if="show">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="panel-title">
          Image Gallery
          <span v-if="setPath">- {{setPath}}</span>
        </div>
        <div class="panel-navtool">
          <div class="search_input">
            <input type="text" v-model="filter.search" placeholder="Type to filter" class="form-control">
          </div>
        </div>
        <div class="panel-action">
          <a href="javascript:;" @click="close()"><i class="ti-close"></i></a>
        </div>
      </div>
      <div class="panel-wrapper">
        <div class="panel-body explorer">
          <div class="row">
            <div 
              v-for="(v,k) in dataPaths" :key="k"
              @click="fileAction(k,v)"
              :class="{'col-sm-2':1,'file-item':1,selected:v.selected}">
              <div class="preview">
                <div class="middleLine"></div>
                <VImg class="thumb" :src="v.thumb"></VImg>
                <div class="icon" v-if="!v.thumb">
                  <i v-if="v.basename=='Up'" class="icon-arrow-up"></i>
                  <i v-else-if="v.extension" class="ti-file"></i>
                  <i v-else class="ti-folder"></i>
                </div>
              </div>
              <span class="filename">{{v.basename.limitChar(40)}}</span>
            </div>
            <h3 v-if="!this.dataPaths.length">
              Image gallery not found
            </h3>
          </div>
        </div>
        <div class="panel-footer">
          <a class="btn btn-info" @click="choose" :disabled="!selectedFiles.length">Choose</a>
          <Uploader name="FileManagerInput" @response="refreshPath()" :type="setPath"></Uploader>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#FileManager{
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 9999;
  width: 100%;
  height: 100%;
  padding: 25px 50px;
  background: rgba(0,0,0,0.4);
  &.inline{
    padding: 0px;
  }
}
.panel{
  height: 100%;
  .panel-wrapper{
    height: calc(100% - 160px);
  }
}
.panel-heading{
  position: relative;
  .panel-title{
    display: inline-block;
    width: 200px;
  }
  .panel-navtool{
    display: inline-block;
    width: calc(100% - 200px - 50px);
    text-align: right;
    > div{ display: inline-block; }
    .search_input{
      width: 200px;
    }
  }
  .panel-action{
    position: absolute;
    top: 25px;
    right: 25px;
  }
}
.explorer{
  height: 100%;
  overflow-y: auto;
}
.file-item{
  text-align: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid transparent;
  margin-right: 5px;
  width: calc(16.667% - 5px);
  &:hover{
    background: rgba(3,169,243,0.1);
  }
  &.selected{
    background: rgba(3,169,243,0.2);
    border: 1px solid rgba(3,169,243,0.4);
  }
  .preview{
    .middleLine{
      display: inline-block;
      vertical-align: middle;
      height: 100%;
      width: 1px;
      margin-left: -1px;
    }
    height: 80px;
    .thumb{
      display: inline-block;
      vertical-align: middle;
      max-width: 80px;
      max-height: 80px;
    }
    .icon{
      display: inline-block;
      i{
        font-size: 70px;
      }
    }
  }
  .filename{
    display: inline-block;
    margin-top: 5px;
    height: 40px;
  }
}
</style>
